import I18n from "i18n-js";
import { makeAutoObservable } from "mobx";
import { OnTimeFulfillmentTime, } from "../../ordering";
export class PTodayFulfillmentTime {
    constructor(params) {
        this.type = "Today";
        this.purchaseOrderFulfillmentTime = params.purchaseOrderFulfillmentTime;
        this.label = I18n.t("orders.form.choose_time");
        makeAutoObservable(this);
    }
    get fulfillmentTime() {
        return this.purchaseOrderFulfillmentTime.fulfillmentTime;
    }
    get isAvailable() {
        return this.purchaseOrderFulfillmentTime.isTodayDateAvailable;
    }
    get isActive() {
        return (this.isAvailable &&
            this.fulfillmentTime !== null &&
            this.fulfillmentTime.type === "OnTime");
    }
    get today() {
        const today = this.purchaseOrderFulfillmentTime.availableDates.findWhere((item) => item.date.isToday);
        if (today === null) {
            throw new Error("Today date is not available.");
        }
        return today;
    }
    get hours() {
        return this.today.hours.map((time) => time.fullHour);
    }
    setDefaultValue() {
        this.purchaseOrderFulfillmentTime.fulfillmentTime =
            new OnTimeFulfillmentTime({
                date: this.today.hours.get(0),
                label: null,
            });
    }
    setDate() {
        throw new Error("Today fulfillment time cannot set date");
    }
    setHour(value) {
        const hour = this.today.hours.findWhere((item) => item.fullHour === value);
        if (hour === null) {
            return;
        }
        this.purchaseOrderFulfillmentTime.fulfillmentTime =
            new OnTimeFulfillmentTime({
                date: hour,
                label: null,
            });
    }
}
